// Paso 4 del asistente (PE-A3b): resultados. Semáforo con color, texto e ícono (se lee sin color).
//   verde = cumple; rojo = no_cumple; amarillo = por_validar; gris = informativo.
// Cada no_cumple muestra norma, artículo o tabla, umbral y valor; cada por_validar dice qué falta y en qué paso.
// Sectores ordenados por Qs con el nivel del RD 164 y la clasificación del AM 1257 Art. 139 (PE-29 sigue abierto:
// solo se ordena y se muestra).

import { calcularCargaFuego, ordenarPorQs } from './pe-carga-fuego';
import type { SectorEnPantalla } from './pe-paso2';
import { sectorAMotor } from './pe-paso2';
import type { Evaluacion } from './pe-paso3';
import type { EstadoTraza, Traza } from './pe-tipos';

export const SEMAFORO: Record<EstadoTraza, { color: string; fondo: string; texto: string; icono: string }> = {
  cumple: { color: '#22c55e', fondo: '#052e16', texto: 'Cumple', icono: '✓' },
  no_cumple: { color: '#ef4444', fondo: '#450a0a', texto: 'No cumple', icono: '✕' },
  por_validar: { color: '#eab308', fondo: '#422006', texto: 'Por validar', icono: '!' },
  informativo: { color: '#94a3b8', fondo: '#1e293b', texto: 'Informativo', icono: 'i' },
};

export const ORDEN_ESTADOS: EstadoTraza[] = ['no_cumple', 'por_validar', 'cumple', 'informativo'];

export const NOMBRE_PASO: Record<number, string> = {
  1: 'Datos generales', 2: 'Sectores', 3: 'Cálculos', 4: 'Resultados', 5: 'Plan de acción', 6: 'Vista previa',
};

export interface TrazaConOrigen extends Traza { evaluacion: string; claveEvaluacion: string }

export function todasLasTrazas(evaluaciones: Evaluacion[], cargaFuego: { titulo: string; trazas: Traza[] }[] = []): TrazaConOrigen[] {
  return evaluaciones.flatMap(ev => ev.trazas.map(t => ({ ...t, evaluacion: ev.titulo, claveEvaluacion: ev.clave })))
    .concat(cargaFuego.flatMap(c => c.trazas.map(t => ({ ...t, evaluacion: c.titulo, claveEvaluacion: 'carga_fuego' }))));
}

export function conteo(trazas: Traza[]): Record<EstadoTraza, number> {
  const c: Record<EstadoTraza, number> = { cumple: 0, no_cumple: 0, por_validar: 0, informativo: 0 };
  for (const t of trazas) c[t.estado]++;
  return c;
}

export interface FilaSectorResultado { nombre: string; qsMJm2: number; nivel: number; categoria: string; art139: string; error?: string }

export function sectoresPorQs(sectores: SectorEnPantalla[]): { filas: FilaSectorResultado[]; trazas: { titulo: string; trazas: Traza[] }[] } {
  const filas: FilaSectorResultado[] = [];
  const trazas: { titulo: string; trazas: Traza[] }[] = [];
  for (const s of sectores) {
    try {
      const r = calcularCargaFuego(sectorAMotor(s));
      filas.push({ nombre: s.sector.name, qsMJm2: r.qsMJm2, nivel: r.nivelRD164.nivel, categoria: r.nivelRD164.categoria, art139: r.clasificacionArt139 });
      trazas.push({ titulo: `Carga de fuego · ${s.sector.name}`, trazas: r.trazas.map(t => (t.estado === 'por_validar' ? { ...t, paso: t.paso ?? 2 } : t)) });
    } catch (e) {
      filas.push({ nombre: s.sector.name, qsMJm2: NaN, nivel: 0, categoria: '—', art139: '—', error: e instanceof Error ? e.message : String(e) });
    }
  }
  const ok = ordenarPorQs(filas.filter(f => !f.error));
  return { filas: ok.concat(filas.filter(f => f.error)), trazas };
}
